const Image = require('./lib/image');

module.exports = Image;
